import * as slick from 'slick-carousel';
import '../scss/slick.scss';
// import { auto } from '@popperjs/core';

document.addEventListener('DOMContentLoaded', () => {
    if (typeof window.jQuery === 'undefined' || !window.jQuery.fn || !window.jQuery.fn.slick) {
        return;
    }

    window.jQuery('.hero-slider').each((_, slider) => {

        const $section = window.jQuery(slider);

        if ($section.hasClass('slick-initialized')) {
            return;
        }

        const totalSlides = slider.querySelectorAll('.front-page-hero__slide').length;
        const $controls = window.jQuery(".hero-slider-mobile-controls");

        $section.on('init reInit afterChange', (_, slick, currentSlide) => {
            const currentIndex = (typeof currentSlide === 'number' ? currentSlide : 0) + 1;

            $controls.find('.hero-slider-mobile-controls__indicator').text(`${currentIndex}/${slick.slideCount}`);
        });

        window.jQuery(slider).slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            infinite: true,
            arrows: true,
            dots: false,
            adaptiveHeight: true,
            autoplay: true,
            autoplaySpeed: 5000,
            responsive: [
                {
                    breakpoint: 9999,
                    settings: {
                        prevArrow: '<div class="slick-arrow-wrapper slick-arrow-wrapper--prev"><button type="button" class="slick-prev"><span class="icon-arrow-left"></span></button></div>',
                        nextArrow: '<div class="slick-arrow-wrapper slick-arrow-wrapper--next"><button type="button" class="slick-next"><span class="icon-arrow-right"></span></button></div>',
                    }
                },
                {
                    breakpoint: 576,
                    settings: {
                        prevArrow: $controls.find('.hero-slider-mobile-controls__arrow--prev'),
                        nextArrow: $controls.find('.hero-slider-mobile-controls__arrow--next'),
                    }
                }
            ]
        });
    });
});

